<template>
  <v-menu
    offset-x max-width="160" max-height="90%"
    :nudge-right="nudgeRight || 4"
    :close-on-content-click="false"
    v-model="open"
  >
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }" />
    </template>
    <v-card class="pa-2" @click.stop>
      <template v-for="color in colors">
        <v-btn
          v-if="color"
          v-blur fab x-small
          class="ma-2"
          style="background-origin: border-box;"
          v-bind:style="{
            'background': `
              linear-gradient(${stripAlpha(color)} 50%, ${color}),
              repeating-conic-gradient(#DDD 0% 25%, transparent 0% 50%) 50% / 20px 20px
            `,
            'outline': value == color ? '8px solid rgba(0, 0, 0, 0.12) !important' : null,
            'box-shadow': value == color ? `0 0 #FFF !important` : null,
            'transform': value == color ? 'scale(.9)' : null
          }"
          @click="$emit('input', color)"
        >
          <v-icon v-if="!color" v-html="mdiCircleOffOutline" />
        </v-btn>
        <v-btn
          v-else
          class="ma-1" icon width="40" height="40"
          :input-value="value == color"
          @click="$emit('input', color)"
        >
          <v-icon v-html="mdiCircleOffOutline" />
        </v-btn>
      </template>
      <div class="ma-n2 pt-4">
        <v-divider />
        <v-list class="pa-0" dense>
          <v-menu offset-x right :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on">
                <v-list-item-title>More colors</v-list-item-title>
                <v-list-item-icon><v-icon v-html="mdiChevronRight" /></v-list-item-icon>
              </v-list-item>
            </template>
            <v-card>
              <div @click.stop>
                <v-color-picker mode="rgba" :value="value" @input="v => $emit('input', v)" />
              </div>
            </v-card>
          </v-menu>
        </v-list>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiChevronRight, mdiCircleOffOutline } from '@mdi/js';

export default {
  name: 'color-picker-btn',

  props: [ 'colors', 'value', 'nudgeRight' ],

  data() {
    return {
      open: false
    };
  },

  created() {
    Object.assign(this, { mdiChevronRight, mdiCircleOffOutline });
  },

  methods: {
    stripAlpha(color) {
      return /^#[0-9a-f]{8}$/i.test(color) ? color.substr(0, 7) : color;
    }
  }
}
</script>
